module.exports = __webpack_public_path__ + "static/media/mobile-components-buttons-icon-buttons-28-dropdown-unfold.a10c218a.svg";